/* eslint-disable */
import React, { ErrorInfo, PropsWithChildren } from 'react';
import ErrorView from 'next/error';
import pkg from '@/../package.json';
import { TermlyRef } from '@/utils/termly';
import { handleUIError } from '@/utils/ui';

type State = {
  error: Error | null;
  info: ErrorInfo | null;
};

type Props = PropsWithChildren<{}>;

const formatComponentStack = (str: string) => {
  const lines = str.split(/\s*\n\s*/g);
  let ret = '';
  for (let line = 0, len = lines.length; line < len; line += 1) {
    if (lines[line].length) ret += `${ret.length ? '\n' : ''}${lines[line]}`;
  }
  return ret;
};

export class ErrorBoundary extends React.Component<Props, State> {
  public constructor(props: Props) {
    super(props);

    this.state = {
      error: null,
      info: null,
    };
  }

  public componentDidMount() {}

  public componentDidCatch(error: Error, info: ErrorInfo) {
    handleUIError(error);
    this.setState({ error, info });
  }

  // eslint-disable-next-line
  public handleClearError = () => {
    this.setState({
      error: null,
    });
  };

  public render() {
    const { error } = this.state;
    const { children } = this.props;

    if (error) {
      return <ErrorView statusCode={500} />;
    }

    return children;
  }
}
